import Swal from 'sweetalert2';
import workflowService from './workflowService';

const PRAZO_LIBERAR_URL_MS = 10 * 60_000;

const mensagemDeErro = (err: any): string => {
  const data = err?.response?.data;
  if (typeof data === 'string' && data) return data;
  return data?.message ?? 'Não foi possível gerar a capa.';
};

/**
 * Abre, numa nova aba, a capa SOX de UMA conciliação (a selecionada): empresa, período, justificativa,
 * evidências e log de aprovação, no padrão visual das capas de conciliação. A pessoa imprime com Ctrl+P
 * (ou pelo botão da própria página) e pode salvar em PDF pelo navegador. A abertura fica registrada
 * no log SOX. Retorna true se a capa foi aberta.
 *
 * A aba é aberta já no clique, antes de esperar a API — se fosse depois, o navegador trataria como
 * pop-up e bloquearia.
 */
export const abrirCapaParaImpressao = async (concilId: number): Promise<boolean> => {
  const aba = window.open('', '_blank');
  if (!aba) {
    Swal.fire({
      icon: 'warning',
      title: 'Pop-up bloqueado',
      text: 'Permita pop-ups deste site no navegador para abrir a capa em outra aba.',
    });
    return false;
  }
  aba.document.title = 'Capa de Conciliação SOX';
  aba.document.body.innerHTML = '<p style="font-family:sans-serif;padding:24px;color:#555">Gerando a capa…</p>';

  try {
    const html = await workflowService.capaHtmlConciliacao(concilId);
    const url = URL.createObjectURL(new Blob([html], { type: 'text/html;charset=utf-8' }));
    aba.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), PRAZO_LIBERAR_URL_MS);
    return true;
  } catch (err: any) {
    aba.close();
    Swal.fire({ icon: 'error', title: 'Erro ao abrir a capa', text: mensagemDeErro(err) });
    return false;
  }
};
